import { render, staticRenderFns } from "./julatHarga.vue?vue&type=template&id=2121f6a2&scoped=true"
import script from "./julatHarga.vue?vue&type=script&lang=js"
export * from "./julatHarga.vue?vue&type=script&lang=js"
import style0 from "./julatHarga.vue?vue&type=style&index=0&id=2121f6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121f6a2",
  null
  
)

export default component.exports